import React from 'react';

import {
  PeoPayrollProviderStaffsListDocument,
  useSendInvitesToPeoPayrollProviderStaffsMutation,
} from 'src/api';
import { useNotification } from 'src/hooks/app';

import { InvitePeoPayrollProviderStaffForm } from './InvitePeoPayrollProviderStaffForm';
import { InviteFormFieldsValues } from './types';

export type InvitePeoPayrollProviderStaffByPEOPPModalFormProps = {
  onCloseModal: () => void;
  switchClosability: (status: boolean) => void;
};

export const InvitePeoPayrollProviderStaffByPEOPPModalForm: React.FC<
  InvitePeoPayrollProviderStaffByPEOPPModalFormProps
> = ({ onCloseModal, switchClosability }) => {
  const { createApolloContext } = useNotification();

  const [sendInvites] = useSendInvitesToPeoPayrollProviderStaffsMutation({
    refetchQueries: [PeoPayrollProviderStaffsListDocument],
    awaitRefetchQueries: true,
    context: createApolloContext(),
  });

  const handleSubmit = React.useCallback(
    async (formFields: InviteFormFieldsValues) => {
      switchClosability(false);

      try {
        await sendInvites({
          variables: {
            staff: formFields.staff,
          },
        });

        switchClosability(true);
        onCloseModal();
      } catch (error) {
        console.error(error);
        switchClosability(true);
      }
    },
    [switchClosability, sendInvites, onCloseModal],
  );

  return <InvitePeoPayrollProviderStaffForm onCloseModal={onCloseModal} onSubmit={handleSubmit} />;
};
